import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Logo.module.less';

function Logo(props) {
  const { fill = '#00C4C9', className, ...otherProps } = props;

  return (
    <svg
      width="94"
      height="94"
      viewBox="0 0 94 94"
      className={clsx(styles.Logo, className)}
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.8483 93.8815C56.2026 93.8815 54.8615 92.5423 54.8579 90.897C54.8568 90.0975 55.1662 89.3471 55.7298 88.7826C56.2935 88.2164 57.0435 87.9041 57.8423 87.9027L88.0158 87.8487L87.9652 58.8829L46.633 17.5497C46.091 17.0077 45.3702 16.7095 44.6023 16.7095C43.8338 16.7095 43.1127 17.0077 42.5707 17.5497C41.4506 18.6714 41.4501 20.4933 42.5698 21.6127L72.2716 51.3153C73.9407 52.9839 74.8601 55.2067 74.8605 57.5748C74.8605 59.9421 73.9414 62.1649 72.2728 63.8333C70.6037 65.5024 68.3811 66.4213 66.0134 66.4213C63.6461 66.4213 61.4229 65.5024 59.7538 63.8333L30.0513 34.1312C29.5095 33.5892 28.7889 33.2907 28.0215 33.2907C27.2529 33.2907 26.5314 33.5901 25.9894 34.1321C25.4471 34.6744 25.1485 35.395 25.1482 36.1626C25.1482 36.9305 25.4458 37.652 25.988 38.194L55.6901 67.8966C59.1414 71.3479 59.1414 76.9646 55.6906 80.4157C54.0221 82.0846 51.7989 83.0037 49.4317 83.0037C47.0639 83.0037 44.8409 82.0846 43.1719 80.4148L0.874231 38.1174C-0.291149 36.9514 -0.291597 35.0551 0.874007 33.8892L34.0368 0.72643C34.6012 0.162001 35.5015 0 36.2999 0C37.0987 0 37.7003 0.162001 38.2654 0.72643C39.4308 1.89226 39.4308 3.78877 38.2654 4.9546L7.21559 36.0042L47.3996 76.1878C47.9412 76.73 48.6629 77.028 49.4312 77.028C50.1989 77.028 50.9204 76.73 51.4624 76.1878C52.5832 75.0672 52.5832 73.2442 51.4624 72.1236L21.7605 42.4224C18.3099 38.9711 18.3099 33.3553 21.761 29.904C23.4301 28.2353 25.6526 27.3153 28.0201 27.3153C30.3874 27.3153 32.6097 28.2353 34.279 29.904L63.9809 59.6051C64.5231 60.1474 65.2448 60.4456 66.0129 60.4456C66.7808 60.4456 67.5021 60.1474 68.0443 59.6051C68.5868 59.0631 68.8846 58.3418 68.8846 57.5739C68.8846 56.8061 68.5868 56.0843 68.0443 55.5425L38.3418 25.84C34.8914 22.3887 34.8914 16.7729 38.3425 13.3218C40.0116 11.6529 42.2341 10.7338 44.6012 10.7338C46.9687 10.7338 49.1912 11.6529 50.8603 13.3218L93.1104 55.5714C93.7607 56.2226 94.0659 57.1303 93.9473 58.0626L94 90.8284C94.0013 91.6272 93.6915 92.3783 93.1279 92.9443C92.5644 93.5098 91.814 93.8219 91.0154 93.8233L57.8528 93.8815H57.8483Z"
      />
    </svg>
  );
}

Logo.displayName = 'Logo';
Logo.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default Logo;
